<template>
  <section class="section" id="campos">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <h1 class="title">
      <a @click="$router.go(-1)">
        <b-icon icon="arrow-left" />
      </a>
      {{companyReference}} - {{dataSelection.companyName}}
    </h1>
    <form onsubmit="return false;">
      <b-field :label="$t('Referencia organización')">
        <b-input disabled :value="companyReference"></b-input>
      </b-field>

      <b-field :label="$t('Nombre organización')">
        <ReactiveBase
          app="ecobanka"
          credentials="ABNjSjm4L:d2f14c64-4601-4dd9-a40c-980c645a92e4"
        >
          <data-search
            @valueChange="updateCompanyName"
            ref="searchCompanyNameField"
            :placeholder="dataSelection.companyName"
            componentId="SearchCompanyName"
            :dataField="['companyName']"
          />
        </ReactiveBase>
      </b-field>

      <b-field :label="$t('Dirección Website organización')">
        <ReactiveBase
          app="ecobanka"
          credentials="ABNjSjm4L:d2f14c64-4601-4dd9-a40c-980c645a92e4"
        >
          <data-search
            @valueChange="updateCompanyWebsite"
            :placeholder="dataSelection.companyWebsite"
            ref="searchCompanyWebsiteField"
            componentId="SearchCompanyWebsite"
            :dataField="['companyWebsite']"
          />
        </ReactiveBase>
      </b-field>

      <b-field :label="$t('Tipo de organización')">
        <b-select
          v-model="dataSelection.companyType"
          :placeholder="$t('Selecciona')"
        >
          <option
            v-for="option in dataOptions.investorCompanyTypes"
            :value="option.id"
            :key="option.id"
          >
            {{ option.title }}
          </option>
        </b-select>
      </b-field>

      <country-advance-select
        :label="'Jurisdicción operativa positiva'"
        :options="dataOptions.countries"
        v-model="dataSelection.countries"
      ></country-advance-select>

      <advance-select
        :label="'Sector actividad operativa'"
        :options="dataOptions.businessSectors"
        v-bind:allLabel="'Multisectorial'"
        v-model="dataSelection.businessSectors"
      ></advance-select>

      <advance-select
        :label="'Fase oportunidad recaudación/fundraising'"
        :options="dataOptions.fundraisingOportunityPhases"
        v-model="dataSelection.fundraisingOportunityPhases"
      ></advance-select>
      <advance-select
        :label="'Tipo de organización aceptadas'"
        :options="dataOptions.requesterCompanyTypes"
        v-model="dataSelection.requesterCompanyTypes"
      ></advance-select>
      <advance-select
        :label="'Tipos de programas de capital en Recaudación/Fundraising'"
        :options="dataOptions.fundraisingProgramTypes"
        v-model="dataSelection.fundraisingProgramTypes"
      ></advance-select>

      <advanced-range-select
        :options="tableDataToListFormat(dataOptions.requestedAmountRanges)"
        v-model="dataSelection.requestedAmountRanges"
        :label="'Criterios de importes de programas de Capital'"
      />

      <b-field :label="$t('Criterios de Cifra de EBITDA para organización')">
        <b-select
          v-model="dataSelection.ebidtaAmountRanges"
          :placeholder="$t('Selecciona')"
        >
          <option
            v-for="option in formatFromList(dataOptions.ebidtaAmountRanges)"
            :value="option.id"
            :key="option.id"
          >
            {{ $t(option.id) }}
          </option>
        </b-select>
      </b-field>

      <advanced-range-select
        :options="tableDataToListFormat(dataOptions.sellsAmountRanges)"
        v-model="dataSelection.sellsAmountRanges"
        :label="'Criterios de importes de Ventas/Facturación'"
      />

      <b-field :label="$t('Criterios de Divisas o Moneda Programa')">
        <advanced-checkbox-group
          v-model="dataSelection.programCurrencyTypes"
          :options="dataOptions.programCurrencyTypes"
        >
        </advanced-checkbox-group>
      </b-field>
      <b-field :label="$t('Criterios auditor de cuentas')">
        <advanced-checkbox-group
          v-model="dataSelection.hasAccountAuditor"
          :options="
            tableDataToListFormat(dataOptions.formQuestions.hasAccountAuditor)
          "
        >
        </advanced-checkbox-group>
      </b-field>

      <b-field :label="$t('Direcciones de contacto')">
        <address-field
          v-model="dataSelection.contactAddress"
          label="Dirección"
        />
      </b-field>
      <b-field :label="$t('Persona de contacto')">
        <b-input
          type="textarea"
          v-model="dataSelection.contactPerson"
        ></b-input>
      </b-field>
      <b-field :label="$t('Casos de éxito')">
        <b-input
          type="textarea"
          v-model="dataSelection.successStories"
        ></b-input>
      </b-field>
      <b-field :label="$t('Noticias de interes')">
        <b-input
          type="textarea"
          v-model="dataSelection.interestingNews"
        ></b-input>
      </b-field>
      <b-field :label="$t('Otros')">
        <b-input type="textarea" v-model="dataSelection.other"></b-input>
      </b-field>
      <b-field>
        <s3-upload-input v-model="dataSelection.files" />
      </b-field>
    </form>
    <hr />
    <div class="buttons">
      <b-button @click="callPostNewInstitution(false)" type="is-primary">{{
        $t('Crear')
      }}</b-button>
      <b-button @click="callPostNewInstitution(true)" type="is-info">{{
        $t('Crear y permanecer')
      }}</b-button>
      <object-viewer :obj="dataSelection" />
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import ObjectViewer from '@/components/common/ObjectViewer.vue'
import S3UploadInput from '@/components/common/S3UploadInput.vue'
import InvestorCompanyTypes from '@/constants/investor_company_types.js'
import AdvanceSelect from '@/components/common/AdvanceSelect.vue'
import CountryAdvanceSelect from '@/components/common/CountryAdvanceSelect.vue'
import AdvancedRangeSelect from '@/components/common/AdvancedRangeSelect.vue'
import Countries from '@/constants/countries.js'
import BusinessSectors from '@/constants/business_sectors.js'
import FundraisingProgramTypes from '@/constants/fundraising_program_types.js'
import RequesterCompanyTypes from '@/constants/requester_company_types.js'
import RequestedAmountRanges from '@/constants/requested_amount_ranges.js'
import EbidtaAmountRanges from '@/constants/ebidta_amount_ranges.js'
import SellsAmountRanges from '@/constants/sells_amount_ranges.js'
import ProgramCurrencyTypes from '@/constants/program_currency_types.js'
import FormQuestions from '@/constants/form_questions.js'
import FundraisingOportunityPhases from '@/constants/fundraising_oportunity_phases.js'
import AdvancedCheckboxGroup from '@/components/common/AdvancedCheckboxGroup.vue'
import AddressField from '@/components/common/AddressField.vue'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'

export default {
  components: {
    AdvanceSelect,
    CountryAdvanceSelect,
    AdvancedRangeSelect,
    AdvancedCheckboxGroup,
    S3UploadInput,
    ObjectViewer,
    AddressField
  },
  mixins: [EnumeratesFormater],
  data: () => ({
    isLoading: false,
    randomId: '',
    dataOptions: {
      countries: null,
      investorCompanyTypes: null,
      businessSectors: null,
      fundraisingProgramTypes: null,
      requesterCompanyTypes: null,
      requestedAmountRanges: null,
      ebidtaAmountRanges: null,
      sellsAmountRanges: null,
      programCurrencyTypes: null,
      fundraisingOportunityPhases: null,
      formQuestions: null
    },
    dataSelection: {
      companyReference: null,
      companyName: '',
      companyType: '',
      companyWebsite: '',
      contactAddress: {
        locality: null,
        country: null
      },
      contactPerson: null,
      successStories: null,
      interestingNews: null,
      other: null,
      countries: [],
      businessSectors: [],
      fundraisingOportunityPhases: [],
      programCurrencyTypes: [],
      fundraisingProgramTypes: [],
      requestedAmountRanges: [],
      requesterCompanyTypes: [],
      ebidtaAmountRanges: null,
      sellsAmountRanges: [],
      hasAccountAuditor: [],
      files: []
    }
  }),
  created() {
    let self = this
    self.randomId = self.genRandomId()
    self.dataOptions = {
      countries: this.formatWorldCountries(Countries),
      investorCompanyTypes: this.objectArrayToList(InvestorCompanyTypes),
      businessSectors: this.objectArrayToList(BusinessSectors),
      fundraisingProgramTypes: this.objectArrayToList(FundraisingProgramTypes),
      requesterCompanyTypes: this.objectArrayToList(RequesterCompanyTypes),
      requestedAmountRanges: RequestedAmountRanges,
      ebidtaAmountRanges: EbidtaAmountRanges,
      sellsAmountRanges: SellsAmountRanges,
      programCurrencyTypes: ProgramCurrencyTypes,
      fundraisingOportunityPhases: this.objectArrayToList(
        FundraisingOportunityPhases
      ),
      formQuestions: FormQuestions
    }
  },
  computed: {
    companyReference: function() {
      if (this.dataSelection.companyReference == null) {
        return this.dataSelection.companyType + this.randomId
      } else {
        return this.dataSelection.companyReference
      }
    }
  },
  mounted() {
    let self = this
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', this.$t(this.$route.meta.title)],
      title: this.$t(this.$t(this.$route.meta.title))
    })

    if (self.$route.name == 'admin.institutions.edit') {
      self.isLoading = true
      self
        .getInstitutionDetails(this.$route.params.id)
        .then(function(response) {
          self.dataSelection = response.data
          self.isLoading = false
        })
        .catch(function() {
          self.isLoading = false
        })
    }
  },
  methods: {
    ...mapActions('institutions', [
      'postNewInstitution',
      'getInstitutionDetails'
    ]),
    updateCompanyName(val) {
      this.dataSelection.companyName = val
    },
    updateCompanyWebsite(val) {
      this.dataSelection.companyWebsite = val
    },
    genRandomId() {
      return Math.random()
        .toString(36)
        .slice(8)
        .toUpperCase()
    },
    callPostNewInstitution(stay = false) {
      let self = this
      self.isLoading = true
      self.dataSelection.companyReference = self.companyReference

      const requestData = self.dataSelection

      self
        .postNewInstitution(requestData)
        .then(function() {
          self.isLoading = false
          if (!stay) {
            self.$router.go(-1)
          }
        })
        .catch(function() {
          self.isLoading = false
          alert('error')
        })
    }
  }
}
</script>
